module.exports = __webpack_public_path__ + "img/ricelog_pinicon_083.0f8f26a2.png";